import React, { useEffect, useState } from 'react';
import { useCollateralSettings, useSaveCollateralSettings } from '../../../services/collateralSettings';
import { formatSouthAfricanDateTime } from '../../../utils/southAfricanTime';

/** Vehicle collateral: how much of the verified retail value is recognised as security (finding #29). */
export default function CollateralSettingsPanel() {
  const settings = useCollateralSettings();
  const save = useSaveCollateralSettings();
  const [percent, setPercent] = useState('');
  const [error, setError] = useState('');
  const [saved, setSaved] = useState(false);
  useEffect(() => { if (settings.data) setPercent(String(Number(settings.data.recognisedPercent))); }, [settings.data]);

  if (settings.isPending) return <p role="status">Loading collateral settings…</p>;
  if (settings.isError) return <div role="alert" className="mb-4">
    <p>Collateral settings could not be loaded.</p>
    <button type="button" className="btn btn-outline-primary" onClick={() => settings.refetch()}>Retry</button>
  </div>;

  const value = Number(percent);
  const valid = percent !== '' && value >= 1 && value <= 100;
  const unchanged = valid && value === Number(settings.data?.recognisedPercent);

  return <form className="mb-5" onSubmit={async event => {
    event.preventDefault(); setError(''); setSaved(false);
    try { await save.mutateAsync({ recognisedPercent: value }); setSaved(true); }
    catch (failure: any) { setError(failure?.response?.data?.message || 'Collateral settings could not be saved.'); }
  }}>
    <h5 className="mb-3">Vehicle collateral</h5>
    <label htmlFor="recognisedPercent" className="form-label">Recognised share of the retail value (%)</label>
    <div className="input-group mb-2" style={{ maxWidth: 220 }}>
      <input id="recognisedPercent" type="number" min={1} max={100} step="0.5" className={`form-control ${percent !== '' && !valid ? 'is-invalid' : ''}`}
        value={percent} disabled={save.isPending} onChange={event => { setPercent(event.target.value); setSaved(false); }} />
      <span className="input-group-text">%</span>
    </div>
    <p className="text-muted small mb-2">
      The loan qualifies up to this share of the vehicle's verified retail value (for example from WeBuyCars). The Credit
      Assessment Procedure Manual sets 70%. It applies to new collateral and to credit reports started after saving.
    </p>
    {settings.data?.modifiedBy && (
      <p className="text-muted small mb-2">
        Last changed by {settings.data.modifiedBy}{settings.data.modifiedDate ? ` · ${formatSouthAfricanDateTime(settings.data.modifiedDate)}` : ''}
      </p>
    )}
    {percent !== '' && !valid && <p className="text-danger small">Enter a percentage from 1 to 100.</p>}
    {error && <p role="alert" className="text-danger">{error}</p>}
    {saved && <p role="status" className="text-success">Collateral settings saved.</p>}
    <button type="submit" className="btn btn-primary" disabled={save.isPending || !valid || unchanged}>
      {save.isPending ? 'Saving…' : 'Save Changes'}
    </button>
  </form>;
}
